import { OldScheduler } from 'apps/webcomponents/src/types/common/maintenanceWindowPatchManagementTypes';
import { RecurrenceOptions } from 'apps/webcomponents/src/types/common/schedulerTypes';
import { padHoursAndMinutes } from '../../padHoursAndMinutes.utils';
import { SchedulerHelper } from '../SchedulerHelper';

export class OldSchedulerHelper extends SchedulerHelper {
  getShortDescription(data: OldScheduler): string {
    switch (data.recurrence) {
      case RecurrenceOptions.IMMEDIATELY:
        return this.dependencies.translateFn('Immediately');
      case RecurrenceOptions.DAILY:
        return this.dependencies.translateFn('Daily at {startTime}', {
          startTime: padHoursAndMinutes`${data.startHour}:${data.startMinute}`,
        });
      case RecurrenceOptions.WEEKLY:
        return this.dependencies.translateFn('Weekly, on {daysOfWeek} at {startTime}', {
          daysOfWeek: data.days?.map(dayNumber => this.getShortDayName(dayNumber)).join(', '),
          startTime: padHoursAndMinutes`${data.startHour}:${data.startMinute}`,
        });
      default:
        return '';
    }
  }
}
